
<script>
import { mapActions } from 'vuex'
import ChartPie from './charts/chart-pie'

export default {
  name: 'DashboardClicksByType',
  components: { ChartPie },
  props: {
    clickTypes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      allClicks: {},
      periods: [
        { value: 'week', label: 'Last Week' },
        { value: 'month', label: 'Last Month' },
        { value: 'year', label: 'Last Year' },
      ],
      selectedPeriod: { value: 'week', label: 'Last Week' },
      requesting: false,
    }
  },
  computed: {
    totalClicks() {
      return Object.values(this.allClicks).reduce((acc, curr) => {return acc + curr}, 0)
    },
    preparedData() {
      return Object.keys(this.allClicks).map(type => {
        const offer = this.clickTypes.find(c => c.name === type)
        const count = this.allClicks[type]

        return {
          label: offer.label,
          fill: offer.fill,
          data: count,
          percentage: Math.round(count * 100 / this.totalClicks),
        }
      })
    },
  },
  created() {
    this.getData()
  },
  methods: {
    ...mapActions('dashboard', ['getClicks', 'getClicksNew']),
    async getData() {
      this.requesting = true
      const res = await this.getClicksNew({
        dataType: 'clicks_by_offer_type',
        period: this.selectedPeriod.value,
      })
      this.allClicks = res
      this.requesting = false
    },
    changePeriod(period) {
      this.selectedPeriod = period
      this.getData()
    },
  },
}
</script>

<template>
  <el-card>
    <div
      slot="header"
      :class="$style.cardHeader"
    >
      Clicks by Offer Type
      <el-dropdown
        trigger="click"
        :class="$style.cardDropdown"
      >
        <span>
          {{ selectedPeriod.label }}
          <i class="el-icon-arrow-down el-icon--right" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(period, index) in periods"
            :key="index"
            @click.native="changePeriod(period)"
          >
            {{ period.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <base-loader v-if="requesting" />
    <chart-pie
      v-else-if="totalClicks"
      :datasets="preparedData"
      :label-template="i => `${i.percentage}% ${i.label}`"
      :height="300"
    />
    <div
      v-else
      :class="$style.chartPieNoData"
    >
      No Data
    </div>
  </el-card>
</template>


<style lang="scss" module>
.cardHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cardDropdown {
  color: var(--color-text-light);
  cursor: pointer;
}

.chartPieNoData {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-light);
  height: rem(303px);
}
</style>
